import React, { createContext, useContext, useState } from 'react';
import { IconSun, IconMoon } from './icons';

const DarkModeContext = createContext({ isDarkMode: false, toggleDarkMode: () => {} });

export function DarkModeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem('enkoDarkMode') === 'dark'
  );
  const toggleDarkMode = () => {
    setIsDarkMode(prev => {
      const next = !prev;
      localStorage.setItem('enkoDarkMode', next ? 'dark' : 'light');
      return next;
    });
  };
  return (
    <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export function useDarkMode() {
  return useContext(DarkModeContext);
}

export function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDarkMode}
      style={{
        width: '44px', height: '24px', borderRadius: '12px',
        backgroundColor: isDarkMode ? '#c9a84c' : '#e0e0e0',
        cursor: 'pointer', position: 'relative',
        transition: 'background-color 0.3s ease', flexShrink: 0,
        border: 'none', padding: 0,
      }}
    >
      <span style={{
        position: 'absolute', top: '3px',
        left: isDarkMode ? '23px' : '3px',
        width: '18px', height: '18px', borderRadius: '50%',
        backgroundColor: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#1a2744',
        transition: 'left 0.3s ease', userSelect: 'none',
      }}>
        {isDarkMode ? <IconMoon size={12} /> : <IconSun size={12} />}
      </span>
    </button>
  );
}
